import { Flex, IconButton } from "@chakra-ui/react";
import { ColumnDef } from "@tanstack/react-table";
import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";

// Note: this column definition only support 1 level of sub-rows because we don't have the use case for multi level sub-rows yet. - AK
export function rowExpanderColumnDef<T>(args: ColumnDef<T>): ColumnDef<T> {
  const { cell, ...columnDef } = args;
  return {
    ...columnDef,
    cell: (c) => {
      const { row } = c;
      const children = row.originalSubRows;
      const showRowButton =
        row.depth === 0 && children !== undefined && children.length > 0;
      return (
        <Flex gap="2" alignItems="center" paddingLeft={showRowButton ? 0 : 8}>
          {showRowButton ? (
            <IconButton
              size="xs"
              fontSize="18px"
              padding="0"
              variant="ghost"
              colorScheme="gray"
              aria-label="Click to expand/collapse"
              onClick={row.getToggleExpandedHandler()}
              icon={
                row.getIsExpanded() ? (
                  <RiArrowDropDownLine />
                ) : (
                  <RiArrowDropRightLine />
                )
              }
            />
          ) : null}
          {typeof cell === "function" ? cell(c) : null}
        </Flex>
      );
    },
  };
}
